<template>
  <div>
    <div>
      <div
        style="position:absolute; left:0px; top:0px; position: absolute; z-index: -1;
      background-image: url('/img/img_sale.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100%;
        height: 540px;"
      ></div>
      <div
        style="position:absolute; left:0px; top:540px; position: absolute; z-index: -1;
      background-color: #111736;
        width: 100%;
        height: 555px;"
      ></div>
      <!-- <parallax v-bind:useScroll=false class="page-header-image" style="background-image:url('/img/img_reward.png'); height: 100vh;"></parallax> -->
      <div id="top" style="margin-top: 60px;">
        <div
          style="width: 100%; margin-top: 125px; height: 394px; background-image: url('/img/bg_sale_deco.png'); background-size: cover; background-position: center center; padding-top: 30px;"
        >
          <div style="text-align: center; position: absolute; left: 0px; top: 105px; width: 100%;">
            <h1
              class="h1"
              style="
            font-size: 2em;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            text-shadow: 2px 2px #000000;
            color: #ffffff;
            "
            >{{$t('1st Pre-sale D-Day')}}</h1>
          </div>
          <div class="col-lg-12" style="text-align: center; height: 50px;">
            <h5
              class="description"
              style="
            font-size: 0.7em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            "
            >{{$t(`presale_desc1`)}}</h5>
            <h5
              class="description"
              style="
            font-size: 0.7em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            margin-top: -10px;
            color: #ffffff;
            "
            >{{$t(`presale_desc2`)}}</h5>
          </div>
          <div style="height: 80px; margin-top: 70px;">
            <flip-countdown
              deadline="2020-05-25 00:00:00.000Z"
              v-bind:labels=labels 
              style="padding-left: 0px !important; padding-right: 0px !important;"
            ></flip-countdown>
          </div>
          <div style="margin-top: 30px; text-align: center; height: 110px;">
            <div
              style="width: 270px; height: 40px; background-image: url('/img/btn_270.png'); font-size: 1.0em; background-size: 100% 100%;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff568; padding-top: 10px; z-index: 10000;"
              @click="goLand()"
              class="btn"
            >{{$t('main_about_land')}}</div>
            <div
              style="width: 270px; height: 40px; background-image: url('/img/btn_270.png'); font-size: 1.0em; background-size: 100% 100%;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #fff568; padding-top: 10px; margin-top: 2px; z-index: 10000;"
              @click="goPresale()"
              class="btn"
            >{{$t('main_about_pre-sale')}}</div>
          </div>
        </div>
      </div>
      <div class="container" id="top2" style="margin-top: 55px;">
        <div style="height: 190px;">
          <img v-bind:src="`/img/text_presale_p1_${localeString}.png`" />
        </div>

        <div style="height: 190px;">
          <img v-bind:src="`/img/text_presale_p2_${localeString}.png`" />
        </div>

        <div style="height: 190px;">
          <img v-bind:src="`/img/text_presale_m_${localeString}.png`" />
        </div>

        <div style="margin-top: 0px;">
          <img src="/img/img_deco_1.png" />
        </div>

        <div class="row" style="margin-top: 30px; width: 100%;">
          <div class="col-lg-8" style="text-align: center; margin: auto;">
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000;
            "
            >{{$t(`presale_desc3`)}}</h5>
            <h5
              class="description"
              style="
            font-size: 1.2em;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            color: #000;
            "
            >{{$t(`presale_desc4`)}}</h5>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <div class="row" style="padding-bottom: 0px;">
              <div class="col-md-6" style="padding: 0;">
                <img v-lazy="'/img/img_sale_1.png'" width="100%" height="100%" />
              </div>
              <div
                class="col-md-6"
                style="background-image: url('/img/bg_sale.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;"
              >
                <h5
                  class="description-game-title text-left"
                  style="padding-left: 20px; padding-top:60px; color: black;"
                >
                  <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px;" />
                  {{$t(`presale_feature_title1`)}}
                </h5>
                <h5
                  class="description-game-desc text-left"
                  style="padding-left: 20px; padding-top:20px; color: black;"
                >{{$t(`presale_feature_desc1`)}}</h5>
              </div>
            </div>
            <div class="row" style="margin-top: 20px;">
              <div class="col-md-6" style="padding: 0;">
                <img v-lazy="'/img/img_sale_2.png'" width="100%" height="100%" />
              </div>
              <div
                class="col-md-6"
                style="background-image: url('/img/bg_sale.png'); min-height: 220px; background-size: cover; background-repeat: no-repeat;"
              >
                <h5
                  class="description-game-title text-left"
                  style="padding-left: 20px; padding-top:60px;"
                >
                  <img v-lazy="'/img/icon_info.png'" style="padding-bottom: 5px; color: black;" />
                  {{$t(`presale_feature_title2`)}}
                </h5>
                <h5
                  class="description-game-desc text-left"
                  style="padding-left: 20px; padding-top:20px; color: black;"
                >{{$t(`presale_feature_desc2`)}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12 col-lg-12"
            style="margin-top: 20px; width: 100%; height: 206px; background-color: #eeeeee;"
          >
            <div style="padding: 10px; height: 100%;">
              <h6
                class="description"
                style="
              font-size: 0.8em;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              text-align: left;
              color: #f24922;
              "
              >
                {{$t(`presale_warn1`)}}
                <br />
                <br />
                {{$t(`presale_warn2`)}}
                <br />
                <br />
                {{$t(`presale_warn3`)}}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Popover } from "element-ui";
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "presale-pre",
  bodyClass: "presale-pre-page",
  components: {
    [Popover.name]: Popover,
    FlipCountdown
  },
  methods: {
    goHomepage: async function() {
      let url = "//www.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goLand: async function() {
      let url =
        "//link.medium.com/7qkosArck6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/85pXZbO5h6";
      }
      else if (this.$i18n.locale == "ch-zn") {
        url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    },
    goPresale: async function() {
      let url =
        "//link.medium.com/xN16Bo1Mp6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/2l6xPJqKo6";
      }
      else if (this.$i18n.locale == "ch-zn") {
        //url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    }
  },
  mounted() {},
  computed: {
    localeString() {
      if (this.$i18n.locale == "ko") {
        return "kr";
      } else if (this.$i18n.locale == "ch-zn") {
        return "cn";
      } else if (this.$i18n.locale == "ja") {
        return "jp";
      } else {
        return "en";
      }
    }
  },
  data: function() {
    return {
      labels: {
          days: this.$t('Days'),
          hours: this.$t('Hours'),
          minutes: this.$t('Minutes'),
          seconds: this.$t('Seconds')
        }
    };
  }
};
</script>
<style>
table,
th,
td {
  border: 1px solid black !important;
  min-width: 240px !important;
  min-height: 240px !important;
}
</style>
